// extracted by mini-css-extract-plugin
module.exports = {"pageHeaderHeight":"88px","pageHeaderHeightMobile":"68px","mycartNavbarHeight":"72px","appLayoutLeftMargin":"20px"};